import React from 'react';
import randomstring from 'uuid/v4';
import { FormattedMessage } from 'react-intl';

import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

import { BlueTickIcon, TrashIcon } from '../../../../images/icons/WrapSvg';

function toolbar(isEdit, handleSubmit, isDelete, handleDelete) {
    const arr = [];
    if (isEdit) {
        arr.push(<BlueTickIcon key={'save-menu-toolbar'} color={'primary'} onClick={handleSubmit} />);
    }
    if (isDelete) {
        arr.push(<TrashIcon key={'delete-menu-toolbar'} color={'secondary'} onClick={handleDelete} />);
    }
    return arr;
}

class List extends React.Component {

    state = {
        rol: undefined,
        error: undefined
    }

    static getDerivedStateFromProps(props, state) {
        const { rol } = props;
        if (rol !== state.rol) {
            state.rol = rol;
            state.rol.nombre = rol.nombre ? rol.nombre : '';
            state.rol.descripcion = rol.descripcion ? rol.descripcion : '';
            state.rol.subroles = rol.subroles && rol.subroles.length > 0 ? rol.subroles : [];
            return state;
        }
        return null;
    }

    componentDidMount() {
        const tools = [toolbar(this.props.clone, this.handleSubmit, !this.props.add && !this.props.clone, this.handleDelete)];
        this.props.setTools(tools);
    }

    componentWillUnmount() {
        this.props.setTools([]);
    }

    handleSubmit = (event) => {
        const { rol } = this.state;
        if (rol.id && !this.props.clone) {
            this.props
                .editRole(rol)
                .then(() => { this.props.history.push('/manage/roles/') })
                .catch((error) => this.props.onError(error.message, error.type));
        } else {
            this.props
                .addRole(rol)
                .then(() => { this.props.history.push('/manage/roles/') })
                .catch((error) => this.props.onError(error.message, error.type));
        }
    }

    handleDelete = (event) => {
        const { rol } = this.state;
        this.props
            .deleteRole(rol.id)
            .then((info) => {
                if (info.success) {
                    this.props.history.push('/manage/roles/')
                } else {
                    this.setState({ error: info })
                }
            })
            .catch((error) => this.props.onError(error.message));
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    }

    handleClick = id => (event) => {
        this.props.history.push('/manage/roles/' + id);
    }

    handleChange = (event) => {
        const { rol } = this.state;
        rol[event.target.name] = event.target.value;
        this.setState({ rol: rol })
        const tools = [toolbar(true, this.handleSubmit, !this.props.clone, this.handleDelete)];
        this.props.setTools(tools);
    }

    handleChecked = (e) => {
        const temp = { ...this.state.rol };
        if (e.target.checked) {
            temp.subroles.push({ id: parseInt(e.target.id, 10) });
        } else {
            const index = temp.subroles.map((s) => s.id.toString()).indexOf(e.target.id);
            temp.subroles.splice(index, 1);
        }
        this.setState({ rol: temp });

        const tools = [toolbar(true, this.handleSubmit, !this.props.clone, this.handleDelete)];
        this.props.setTools(tools);
    }

    handleCloseError = (e) => {
        this.setState({ error: undefined })
    }

    render() {
        const { roles_app, intl, levels, info, id, clone } = this.props;
        const { rol, error } = this.state;
        if (error) {
            console.log(error);
            return <div className={'flex_full_column height100'}>
                <div className="flex_full overflow_y_scroll showbar padding_borders bg_lipstickligth" onScroll={this.handleScroll}>
                    <div className="flex_auto_row c_white elements_from_right">
                        <IconButton aria-label="close" className="c_white" onClick={this.handleCloseError}>
                            <CloseIcon />
                        </IconButton>
                    </div>
                    <div className="flex_auto_row barlowsemicondensed_bold c_white center margin_bottom_24">
                        {error.message}
                    </div>
                    {error.data &&
                        <div className="flex_full_column">
                            {(error.data.proceso && error.data.proceso.length > 0) &&
                                <div className="flex_auto_row barlowsemicondensed_bold_small c_white margin_bottom_12 margin_top_24 ">
                                    <FormattedMessage id="manage_checks_menu" />
                                </div>
                            }
                            {(error.data.proceso && error.data.proceso.length > 0) &&
                                error.data.proceso.map((p) =>
                                    <div className="flex_auto_row barlow_regular_small c_white margin_bottom_12 ">
                                        {" - " + p.nombre}
                                    </div>
                                )
                            }
                            {(error.data.usuario && error.data.usuario.length > 0) &&
                                <div className="flex_auto_row barlowsemicondensed_bold_small c_white margin_bottom_12 margin_top_24 ">
                                    <FormattedMessage id="manage_user_menu" />
                                </div>
                            }
                            {(error.data.usuario && error.data.usuario.length > 0) &&
                                error.data.usuario.map((p) =>
                                    <div className="flex_auto_row barlow_regular_small c_white margin_bottom_12 ">
                                        {" - " + p.nombre}
                                    </div>
                                )
                            }
                            {(error.data.plantilla && error.data.plantilla.length > 0) &&
                                <div className="flex_auto_row barlowsemicondensed_bold_small c_white margin_bottom_12 margin_top_24 ">
                                    <FormattedMessage id="manage_template_menu" />
                                </div>
                            }
                            {(error.data.plantilla && error.data.plantilla.length > 0) &&
                                error.data.plantilla.map((p) =>
                                    <div className="flex_auto_row barlow_regular_small c_white margin_bottom_12 ">
                                        {" - " + p.nombre}
                                    </div>
                                )
                            }
                        </div>
                    }
                </div>
            </div>
        }
        return (
            <div className={'flex_full_column height100'}>
                <div className="flex_full overflow_y_scroll showbar padding_borders" onScroll={this.handleScroll}>
                    {id &&
                        <div className="flex_auto_row center padding_borders c_white bg_pea">
                            <FormattedMessage id="form_field_edit" />
                        </div>
                    }
                    {clone &&
                        <div className="flex_auto_row center padding_borders c_white bg_lipstick">
                            <FormattedMessage id="form_field_clone" />
                        </div>
                    }

                    <div className="flex_full_row margin_top_12">
                        <TextField
                            id="nombre"
                            name="nombre"
                            fullWidth
                            label={intl.formatMessage({ id: 'form_field_name_nombre' })}
                            className="margin_bottom_12 padding_top_24"
                            value={rol.nombre}
                            onChange={this.handleChange}
                            InputLabelProps={{ shrink: true }}
                        />
                    </div>
                    <div className="flex_full_row margin_top_12">
                        <TextField
                            id="descripcion"
                            name="descripcion"
                            fullWidth
                            label={intl.formatMessage({ id: 'form_field_description' })}
                            className="margin_bottom_12 padding_top_24"
                            value={rol.descripcion}
                            onChange={this.handleChange}
                            InputLabelProps={{ shrink: true }}
                        />
                    </div>
                    <div className="flex_full_row margin_top_12 align_center">
                        <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                            <InputLabel htmlFor="nivel" shrink>
                                {intl.formatMessage({ id: 'form_field_level' })}
                            </InputLabel>
                            <Select
                                native
                                name="nivel"
                                value={rol.nivel}
                                onChange={this.handleChange}
                                inputProps={{ name: 'nivel', id: 'nivel' }}
                            >
                                <option key={randomstring()} value={undefined} />
                                {
                                    levels.map((l) => <option key={randomstring()} value={l} >{l}</option>)
                                }
                            </Select>
                        </FormControl>
                    </div>
                    <div className="flex_full_row c_dark_grey_blue barlow_semibold padding_top_24 margin_bottom_24">
                        <FormattedMessage id="form_field_permission" />
                    </div>
                    <div className="flex_full_column margin_top_12">
                        {
                            info.security.licencias
                                .filter((f) => f.activo)
                                .sort((a, b) => a.id > b.id ? 1 : -1)
                                .map((l) => {
                                    const permisos = roles_app.filter((f) => f.licencia === l.id);
                                    if (permisos.length > 0) {
                                        return (
                                            <div key={randomstring()} className="flex_auto_column">
                                                <div className="flex_auto_row barlow_regular_small margin_bottom_12">
                                                    {l.nombre}
                                                </div>
                                                {
                                                    permisos
                                                        .sort((a, b) => a.nombre > b.nombre ? 1 : -1)
                                                        .map((r) =>
                                                            <div key={randomstring()} className="flex_auto_row align_center">
                                                                <Switch
                                                                    id={r.id.toString()}
                                                                    checked={rol && rol.subroles && rol.subroles.map((s) => s.id).indexOf(r.id) >= 0}
                                                                    onChange={this.handleChecked}
                                                                    value="saved"
                                                                    color="primary"
                                                                />
                                                                <div className="flex_auto_row barlow_regular_small ">
                                                                    {r.nombre}
                                                                </div>
                                                            </div>
                                                        )
                                                }
                                            </div>
                                        )
                                    }
                                    return <div key={randomstring()} />;
                                })
                        }
                    </div>
                </div>

            </div>
        )
    }
}

export default List;



// WEBPACK FOOTER //
// ./src/components/complex/manage/roles/application.js